// Generated by ReScript, PLEASE EDIT WITH CARE

import * as BsCssJs$PrezzeeRibbon from "../bindings/BsCss/BsCssJs.bs.js";
import * as Theme__Fonts$PrezzeeRibbon from "./Theme__Fonts.bs.js";

var style1_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(40)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(56)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("bold")
];

var style1 = BsCssJs$PrezzeeRibbon.style(style1_);

var style2_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(32)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(40)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("bold")
];

var style2 = BsCssJs$PrezzeeRibbon.style(style2_);

var style3_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(24)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(32)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("medium")
];

var style3 = BsCssJs$PrezzeeRibbon.style(style3_);

var style4_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(20)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(28)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("medium")
];

var style4 = BsCssJs$PrezzeeRibbon.style(style4_);

var style5_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(18)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(24)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var style5 = BsCssJs$PrezzeeRibbon.style(style5_);

var style5Btn_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(18)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var style5Btn = BsCssJs$PrezzeeRibbon.style(style5Btn_);

var style6_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(14)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(24)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var style6 = BsCssJs$PrezzeeRibbon.style(style6_);

var style7_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(12)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(20)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var style7 = BsCssJs$PrezzeeRibbon.style(style7_);

var h1_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(2.5)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(50)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var h1 = BsCssJs$PrezzeeRibbon.style(h1_);

var h2_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(2.0)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(42)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("bold")
];

var h2 = BsCssJs$PrezzeeRibbon.style(h2_);

var h3_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.5)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(34)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var h3 = BsCssJs$PrezzeeRibbon.style(h3_);

var h4_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.375)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(30)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var h4 = BsCssJs$PrezzeeRibbon.style(h4_);

var h5_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.25)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(28)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var h5 = BsCssJs$PrezzeeRibbon.style(h5_);

var h6_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(1.125)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(28)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("semiBold")
];

var h6 = BsCssJs$PrezzeeRibbon.style(h6_);

var body_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.px(16)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(24)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var body = BsCssJs$PrezzeeRibbon.style(body_);

var smallBody_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(0.875)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(22)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var smallBody = BsCssJs$PrezzeeRibbon.style(smallBody_);

var tiny_ = [
  Theme__Fonts$PrezzeeRibbon.SofiaPro.family,
  BsCssJs$PrezzeeRibbon.fontSize(BsCssJs$PrezzeeRibbon.rem(0.75)),
  BsCssJs$PrezzeeRibbon.lineHeight(BsCssJs$PrezzeeRibbon.px(18)),
  BsCssJs$PrezzeeRibbon.margin(BsCssJs$PrezzeeRibbon.zero),
  BsCssJs$PrezzeeRibbon.fontWeight("normal")
];

var tiny = BsCssJs$PrezzeeRibbon.style(tiny_);

var Styles = {
  style1_: style1_,
  style1: style1,
  style2_: style2_,
  style2: style2,
  style3_: style3_,
  style3: style3,
  style4_: style4_,
  style4: style4,
  style5_: style5_,
  style5: style5,
  style5Btn_: style5Btn_,
  style5Btn: style5Btn,
  style6_: style6_,
  style6: style6,
  style7_: style7_,
  style7: style7,
  h1_: h1_,
  h1: h1,
  h2_: h2_,
  h2: h2,
  h3_: h3_,
  h3: h3,
  h4_: h4_,
  h4: h4,
  h5_: h5_,
  h5: h5,
  h6_: h6_,
  h6: h6,
  body_: body_,
  body: body,
  smallBody_: smallBody_,
  smallBody: smallBody,
  tiny_: tiny_,
  tiny: tiny
};

export {
  Styles ,
}
/* style1_ Not a pure module */
